<template>
  <div>
    <form>
      <MnLoader :visible="formState.state.loading" :message="formState.state.loadingMessage" />
      <div v-if="formState.state.data != null" class="py-3">
        <Fluid>
          <MnRow>
            <MnColumn cols="6">
              <FormInputGroup label="First Name"
                              inputId="first-name-input"
                              :state="formState.state.$v.firstName.$error"
                              :errorMessage="formState.state.$v.firstName.$errors[0]?.$message"
                              required>
                <template #default="{ state, updateState }">
                  <PvInputText id="first-name-input"
                               v-model="formState.state.$v.firstName.$model"
                               :invalid="state"
                               @input="updateState($event)" autofocu />
                </template>
              </FormInputGroup>
            </MnColumn>
            <MnColumn cols="6">
              <FormInputGroup label="Last Name"
                              inputId="last-name-input"
                              :state="formState.state.$v.lastName.$error"
                              :errorMessage="formState.state.$v.lastName.$errors[0]?.$message"
                              required>
                <template #default="{ state, updateState }">
                  <PvInputText id="last-name-input"
                               v-model="formState.state.$v.lastName.$model"
                               :invalid="state"
                               @input="updateState($event)" />
                </template>
              </FormInputGroup>
            </MnColumn>
          </MnRow>
          <MnRow>
            <MnColumn>
              <FormInputGroup label="Address"
                              inputId="address-input"
                              :state="formState.state.$v.address1.$error"
                              :errorMessage="formState.state.$v.address1.$errors[0]?.$message"
                              required>
                <template #default="{ state, updateState }">
                  <PvInputText id="address-input"
                               v-model="formState.state.$v.address1.$model"
                               :invalid="state"
                               @input="updateState($event)" />
                </template>
              </FormInputGroup>
            </MnColumn>
          </MnRow>
          <MnRow>
            <MnColumn>
              <FormInputGroup label="Address 2"
                              inputId="address2-input"
                              :state="formState.state.$v.address2.$error"
                              :errorMessage="formState.state.$v.address2.$errors[0]?.$message">
                <template #default="{ state, updateState }">
                  <PvInputText id="address2-input"
                               v-model="formState.state.$v.address2.$model"
                               :invalid="state"
                               @input="updateState($event)" />
                </template>
              </FormInputGroup>
            </MnColumn>
          </MnRow>
          <MnRow>
            <MnColumn cols="5">
              <FormInputGroup label="City"
                              inputId="city-input"
                              :state="formState.state.$v.city.$error"
                              :errorMessage="formState.state.$v.city.$errors[0]?.$message"
                              required>
                <template #default="{ state, updateState }">
                  <PvInputText id="city-input"
                               v-model="formState.state.$v.city.$model"
                               :invalid="state"
                               @input="updateState($event)" />
                </template>
              </FormInputGroup>
            </MnColumn>
            <MnColumn cols="3">
              <FormInputGroup label="State"
                              inputId="state-input"
                              :state="formState.state.$v.stateProvince.$error"
                              :errorMessage="formState.state.$v.stateProvince.$errors[0]?.$message"
                              required>
                <template #default="{ state, updateState }">
                  <PvSelect v-model="formState.state.$v.stateProvince.$model"
                            :options="states"
                            :invalid="state"
                            optionValue="value"
                            optionLabel="text"
                            input-id="state-input"
                            placeholder="Select a State"
                            @input="updateState($event)" />
                </template>
              </FormInputGroup>
            </MnColumn> 
            <MnColumn cols="4">
              <FormInputGroup label="Postal Code"
                              inputId="postal-input"
                              :state="formState.state.$v.postalCode.$error"
                              :errorMessage="formState.state.$v.postalCode.$errors[0]?.$message"
                              required>
                <template #default="{ state, updateState }">
                  <PvInputMask id="postal-input"
                               v-model="formState.state.$v.postalCode.$model"
                               mask="99999?-9999"
                               :invalid="state"
                               @input="updateState($event)" />
                </template> 
              </FormInputGroup>
            </MnColumn>    
          </MnRow>
          <MnRow>
            <MnColumn cols="4">

              <FormInputGroup label="Phone"
                              inputId="phone-input"
                              :state="formState.state.$v.phone.$error"
                              :errorMessage="formState.state.$v.phone.$errors[0]?.$message"
                              required>
                <template #default="{ state, updateState }">
                  <PvInputMask id="phone-input"
                               v-model="formState.state.$v.phone.$model"
                               mask="(999) 999-9999"
                               :invalid="state"
                               @input="updateState($event)" />
                </template>
              </FormInputGroup>
            </MnColumn>
            <MnColumn cols="2">
              <FormInputGroup label="Ext"
                              inputId="ext-input"
                              :state="formState.state.$v.phoneExtension.$error"
                              :errorMessage="formState.state.$v.phoneExtension.$errors[0]?.$message">
                <template #default="{ state, updateState }">
                  <PvInputText id="ext-input"
                               v-model="formState.state.$v.phoneExtension.$model"
                               :invalid="state"
                               @input="updateState($event)" />
                </template>
              </FormInputGroup>
            </MnColumn>
            <MnColumn cols="6">
              <FormInputGroup label="Email"
                              inputId="email-input"
                              :state="formState.state.$v.email.$error"
                              :errorMessage="formState.state.$v.email.$errors[0]?.$message"
                              required>
                <template #default="{ state, updateState }">
                  <PvInputText id="email-input"
                               :disabled="!formState.state.data.isNew"
                               v-model="formState.state.$v.email.$model"
                               :invalid="state"
                               @input="updateState($event)" />
                </template>
              </FormInputGroup>
            </MnColumn>
          </MnRow>
          <!-- <MnRow v-if="!formState.state.data.isPendingApproval">
            <MnColumn>
              <div class="d-flex justify-content-center border rounded p-3">
                <div class="text-center me-3">
                  <label for="active-switch" class="mb-2">Contact Status</label>
                  <div>
                    <ToggleButton id="active-switch" :disabled="formState.state.data.isNew" onLabel="Active" class="toggle-btn" onIcon="pi pi-check-circle" severity="success" offLabel="Inactive" offIcon="pi pi-times-circle" @change="onStatusChanged" v-model="formState.state.$v.isActive.$model"  />
                  </div>
                </div>
                <div class="text-center">
                  <label for="portal-access-switch" class="mb-2">Portal Access</label>
                  <div>
                    <ToggleButton id="portal-access-switch" :disabled="!formState.state.$v.isActive.$model" class="toggle-btn" onLabel="Has Access" onIcon="pi pi-check-circle" offLabel="No Access" offIcon="pi pi-times-circle" v-model="formState.state.$v.isPortalUser.$model"  />
                  </div>
                </div>
              </div>
            </MnColumn>
          </MnRow> -->
        </Fluid>
      </div>
    </form>
    <ErrorMessage id="error-msg" :visible="formState.state.error" :message="formState.state.errorMessage" />
  </div>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { onMounted, nextTick } from 'vue';

// Components
import Fluid from 'primevue/fluid';
import MnRow from '@/components/common/MnRow.vue';
import MnColumn from '@/components/common/MnColumn.vue';
import MnLoader from '../common/MnLoader.vue';
import FormInputGroup from '@/components/common/FormInputGroup.vue';
import ErrorMessage from '../common/ErrorMessage.vue';

// Composables
import { useStateOptions } from '@/composables/commonOptions';
import { useForm } from '@/composables/form';
import { ContactModel } from '@/models/ContactModel';

// Stores

// Constants and Utils

// ===============================
// PROPS & EMITS
// ===============================
const props = defineProps({  
  organizationId: {
      type: Number,
      required: true,
      default: null
  },
  contactId: {
      type: Number,
      default: null
  }
});

const emit = defineEmits(['data-saved', 'data-canceled']);

// ===============================
// COMPOSABLES & STORES
// ===============================
const states = useStateOptions();

const formState = useForm(new ContactModel(), ContactModel.getValidationRules());

// ===============================
// REACTIVE STATE
// ===============================
// const organizations = ref(null);

// ===============================
// CONSTANTS
// ===============================

// ===============================
// COMPUTED PROPERTIES
// ===============================

// ===============================
// METHODS
// ===============================
const onSubmit = async () => {
  formState.state.$v.$touch();
  if (formState.state.$v.$invalid) {
      nextTick(() => formState.focusInvalidInput());
    } else {
       await formState.save(() => formState.state.data.save());
      if (formState.state.success) {
        emit('data-saved');
      } else {
        formState.focusErrorMessage('error-msg');
      }      
    }
  };

const onCancel = () => {
    emit('data-canceled');
};

const initializePage = async () => {
  // if (props.organizationId) {
  //   // Get the primary organizations for the contact
  //   organizations.value = await getContactPrimaryOrganizations(props.organizationId);
  // }

  if (props.contactId) {
    // Get the contact to edit
    await formState.state.data.fetch(props.contactId);
  } else {
    formState.state.data.primaryOrganizationId = props.organizationId;
  }
};

// ===============================
// WATCHERS
// ===============================

// ===============================
// LIFECYCLE HOOKS
// ===============================
onMounted(async () => {
 await formState.fetch(() => initializePage());

 nextTick(() => formState.setFocus('first-name-input'));
});

// ===============================
// EXPOSE
// ===============================
defineExpose({ onSubmit, onCancel });

</script>

<style scoped>
.toggle-btn {
  width: 10rem;
}
</style>